export default "__VITE_ASSET__BdTZk_6m__"